import { render, staticRenderFns } from "./ToastAlert.vue?vue&type=template&id=384ea4e5&"
import script from "./ToastAlert.vue?vue&type=script&lang=ts&"
export * from "./ToastAlert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports